import _cloneDeep from 'clone';
import * as LoaderUtils from "../../wui-core/src/LoaderUtils";
const DynamicPlugin = {
    ajaxGetJson: (url:string, callback?:any)=>{
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.timeout = 120000; // 单位ms
        xmlhttp.open('get', url, true);
        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState === XMLHttpRequest.DONE && xmlhttp.status === 200) {
                try {
                    let result = JSON.parse(xmlhttp.responseText);
                    typeof callback == 'function' && callback(result);
                    return result;
                } catch (e) {}
            }
        };
        let fail = function() {
        };
        xmlhttp.onabort = fail;
        xmlhttp.onerror = fail;
        xmlhttp.ontimeout = fail;
        xmlhttp.send();
    },
    /**
     * 初始化原有事件信息
     * options{
     * 		page:被扩展的页面
     * 		uiEvent:被扩展的原始事件数据
     * }
     */
    pluginInit: function(options:{page:any, uiEvent:any}) {
        let {page, uiEvent} = options || {};
        if (!page) return;
        let loadPath = page.getJsPluginUrl();
        let pageCode = page.getPageCode();
        if (loadPath && pageCode && uiEvent) {
            if (window["YYPlugin_" + pageCode]) {
                // 判断方法是否存在
                DynamicPlugin.pluginMerge(options); // 合并
            } else {
                LoaderUtils.loadJS(loadPath, function() {
                    DynamicPlugin.pluginMerge(options); // 合并
                })
            }
        }
    },
    /**
     * 合并文件
     * options{
     * 		page:被扩展的页面
     * 		uiEvent:被扩展的原始事件数据
     * }
     */
    pluginMerge: function(options:{page:any, uiEvent:any}) {
        let {page, uiEvent} = options || {};
        if (!page) return;
        let loadPath = page.getJsPluginUrl();
        let pageCode = page.getPageCode();
        if (loadPath && pageCode && uiEvent) {
            if (window["YYPlugin_" + pageCode]) {
                let pluginEvents = this.dealPluginEvent(page, window["YYPlugin_" + pageCode](page));
                let allEvent = this.combineEvent(pluginEvents, uiEvent);// 合并所有的事件
                let returnEvent = this.transEvent(allEvent, page);// 绑定所有的事件
                page.refresh(function() {
                    page._callEvent("onPluginDidMount", { uiEvent: returnEvent, uiMeta: page.props.uiMeta })
                }, { uiEvent: returnEvent });
            } else {
                console.error("[TNS]请按规范命名当前页面扩展插件的方法名，缺少方法：YYPlugin_" + pageCode)
            }
        }
    },
    dealPluginEvent: function(page:any, copyEvents:any) {
        for (let uikey in copyEvents) {
            let itemEvents = copyEvents[uikey];
            for (let name in itemEvents) {
                if (itemEvents[name] && typeof itemEvents[name] == 'function') {
                    itemEvents[name] = itemEvents[name].bind(page);
                } else {
                    console.error('[TNS]绑定事件失败：' + uikey + '.' + name + ',检查是否为有效的Function');
                }
            }
        }
        return copyEvents;
    },
    // 合并事件对象  并不是简单地覆盖而是对象合并
    combineEvent: function(pluginEvents:any, _uiEvent:any) {
        for (let item in _uiEvent) {
            if (pluginEvents[item]) {
                Object.assign(_uiEvent[item], pluginEvents[item]);// 合并
            }
        }
        for (let item in pluginEvents) {
            if (!_uiEvent[item]) {
                _uiEvent[item] = pluginEvents[item]
            }
        }
        return _uiEvent;
    },
    // 判断该事件是否在插件中不存在  如果不存在 则不对该事件进行promise的处理 否则会影响流程的问题
    hasEvent: function(key:string, eventName:string, copyEvents:any) {
        if (copyEvents && copyEvents[key] && copyEvents[key][eventName] && typeof copyEvents[key][eventName] == "function") {
            return true;
        }
        return false;
    },
    transEvent: function(uiEvent:any, page:any) {
        // 注意此次需要克隆，以防止引用共享
        // 扩展事件规则   事件发生前    前加 before_  事件发生后 after_
        let _uiEvent = _cloneDeep(uiEvent);
        for (let uikey in _uiEvent) {
            for (let eventName in _uiEvent[uikey]) {
                let hasEvent = DynamicPlugin.hasEvent(uikey, eventName, window["YYPlugin_" + page.getPageCode()](page));
                if (hasEvent && eventName.indexOf('before_') == -1 && eventName.indexOf('after_') == -1) {
                    (function(key, name) {
                        let originFunc = _uiEvent[key][name];
                        _uiEvent[key][name] = function() {
                            let originFuncParams = arguments;
                            new Promise(function(resolve) {
                                console.log("执行" + key + "组件事件:" + name);
                                resolve("success");
                            }).then(function() {
                                if (_uiEvent[key]["before_" + name]) {
                                    return _uiEvent[key]["before_" + name].apply(page, originFuncParams); // 将触发前事件放入事件数组
                                }
                            }).then(function() {
                                return originFunc.apply(page, originFuncParams); // 固有事件
                            }).then(function() {
                                if (_uiEvent[key]["after_" + name]) {
                                    _uiEvent[key]["after_" + name].apply(page, originFuncParams); // 将触发前事件放入事件数组
                                }
                            }).catch(function(msg) {
                                console.log(msg)
                            });
                        };
                    })(uikey, eventName);
                }
            }
        }
        return _uiEvent;
    }
}
export default DynamicPlugin;
